<footer id="app-footer" *ngIf="!nativeCallService.isNativeIos">
  <div class="footer-message">
    {{'general.NEED_HELP_QUESTION' | transloco}}
    <a href="mailto:help@quantified.ai">{{'general.HELP_EMAIL' | transloco}}</a>
  </div>
</footer>
